import * as fonts from './fonts';

const p100Color = '#232A5C';
const oldp100Color = '#3c2a8e';

const tokens = {
  // https://crossbordersolutions.invisionapp.com/share/QW1024KA5PTX#/447962393_Colour

  /**
   * REBRANDING COLORS
   * Blue: '#232a5c'
   * Green: '#06ab71'
   *
   * Our approach will be to _replace_ existing colors below with the new colors.
   * This *should* replace the existing colors app-wide with the new colors in one move.
   * For example, `product100` will be updated from the existing purple color #3c2a8e to the new dark blue #232a5c
   *
   * Our approach is NOT to create new named colors for the new branding.
   */

  core1: '#464d59',
  core2: '#677283',
  core3: '#363636',
  core4: '#10c585',
  error15: '#FCDFD2',
  error25: '#FAB9A6',
  error100: '#B4192E',
  error200: '#97112F',
  muiError: '#f44336',
  neutral300: '#E7E8E9',
  neutral100: '#8e949f',
  neutral95: '#c5c5c9',
  neutral90: '#e2e3e6',
  neutral80: '#efeff2',
  neutral70: '#f5f5f7',
  neutral60: '#faf9fa',
  pActive: '#6E56DB',
  primaryThemeAP15: '#EEE9FF',
  primaryThemeAP90: '#4A36A7',
  primaryThemeAP95: '#37278F',
  product10: '#f9f8fe',
  product100: p100Color,
  product100Light: '#232a5cc9',
  oldProduct100: oldp100Color,
  progress20: '#faeab7',
  product90: '#4a36a7',
  product25: '#dcdbfe',
  product15: '#efefff',
  supportColorA20: '#c9e7f1',
  supportColorA15: '#e5f4f9',
  supportColorA100: '#0376a0',
  themeAp100: p100Color,
  black: '#000000',
  blackAlpha20: '#00000033',
  white: '#ffffff',
  purple: '#bd6dff',
  purpleLight1: '#8d74ff',
  purpleLight2: '#6e56db',
  purpleLight3: '#fbfbff',
  pink: '#c940e0',
  mustard: '#FEF7E0',
  darkMustard: '#82703A',
  positive100: '#11794F',
  positive70: '#2AC788',
  positive15: '#D9FAED',
  acceptedBackground100: '#D9FAED',
  acceptedText100: '#11794F',
  spacing: 12,
  spacing4xs: '0.25rem', // 4px
  spacing3xs: '0.5rem',  // 8px
  spacing2xs: '0.75rem', // 12px
  spacingxs: '1rem',     // 16px
  spacings: '1.5rem',    // 24px
  spacingmd: '2rem',     // 32px
  spacinglg: '2.5rem',   // 40px
  spacingxl: '3rem',     // 48px
  spacing2xl: '3.5rem',  // 56px
  spacing3xl: '4rem',    // 64px
  spacing4xl: '5rem',    // 80px
  spacing5xl: '6rem',    // 96px
  spacing6x1: '7rem',    // 112px
  spacing7xl: '7.75rem', // 124px
  spacing8xl: '9rem',    // 144px
  ...fonts,
  baseFontSize: 14
};

export default tokens;
